import { render, staticRenderFns } from "./HelpFooter.vue?vue&type=template&id=2633a228"
import script from "./HelpFooter.vue?vue&type=script&lang=ts"
export * from "./HelpFooter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports